import { DirectiveOptions } from 'vue';
import './index.scss';

/**
 * 计算右键容器的坐标X/Y
 * @param view 浏览器可视区域的长/宽
 * @param container 右键容器的长/宽
 * @param mouse 鼠标的坐标X/Y
 * @returns
 * @todo 避开鼠标坐标
 */
const computeCoord = (view: number, container: number, mouse: number, offset = 0) => {
  const MARGIN = 10; // 安全外边距
  if (mouse + container + MARGIN <= view) {
    return mouse - offset;
  }
  return mouse - container + offset;
};
const getElementBySelector = (selector: string | HTMLElement): HTMLElement | null => {
  if (typeof selector === 'string') {
    return document.querySelector(selector);
  }
  if (typeof selector === 'object') {
    return selector;
  }
  return null;
};
const removeChild = (child: HTMLElement): void => {
  const parent = child.parentNode;
  if (parent) parent.removeChild(child);
};

/**
 * 将修饰元素注册为目标元素的右键内容
 */
const directive: DirectiveOptions = {
  bind: (contentNode, binding) => {
    contentNode.style.display = 'none'; // 初始化默认不显示
  },

  componentUpdated: (contentNode, binding) => {
    // 指令修饰的节点为[内容节点]
    // [内容节点]首先会被从其[父节点]中移除，随后
    // [内容节点]会被挂载到[容器节点]上（容器节点用于统一 CSS 行为）
    // [容器节点]会被挂载到[目标节点]上（目标节点可能是选择器节点或父节点）
    const { value } = binding;
    const { targetSelector, listenerSelector, scollSelect, listenerCallback, menuShowCallback } = value || {};
    const parentNode = contentNode.parentElement || document.documentElement;
    const targetNode = getElementBySelector(targetSelector) || parentNode;
    const scollNode = getElementBySelector(scollSelect) || null;
    const listenerNodeList = document.querySelectorAll(listenerSelector).length
      ? document.querySelectorAll(listenerSelector)
      : [targetNode];
    const containerNode = document.createElement('div');
    containerNode.setAttribute('class', 'smh-right-click');
    const scrollEvent = () => {
      removeChild(containerNode);
    };
    const hiddenRightClickEvent = (e: MouseEvent) => {
      if (e.button === 0) {
        // 当按下鼠标左键时，不移除，等待 click 事件冒泡回归后再移除
        document.addEventListener(
          'click',
          () => {
            if (menuShowCallback) {
              menuShowCallback(false);
            }
            removeChild(containerNode);
            if (scollNode) {
              scollNode.removeEventListener('scroll', scrollEvent);
            }
          },
          {
            once: true,
          },
        );
      } else {
        if (menuShowCallback) {
          menuShowCallback(false);
        }
        removeChild(containerNode);
        if (scollNode) {
          scollNode.removeEventListener('scroll', scrollEvent);
        }
      }
    };
    for (const listenerNode of listenerNodeList) {
      // 监听目标节点的右键事件
      listenerNode.oncontextmenu = (event: MouseEvent) => {
        // 执行回调函数并判断是否继续
        let isContinue = true;
        if (listenerCallback) {
          isContinue = listenerCallback(event);
        }
        if (isContinue) {
          // 获取浏览器可视区域尺寸
          const { innerWidth, innerHeight } = window;
          removeChild(contentNode);
          // 获取内容元素的尺寸（元素可见后方可获取尺寸）
          containerNode.appendChild(contentNode);
          targetNode.appendChild(containerNode);
          const { clientWidth, clientHeight } = containerNode;
          // 获取鼠标坐标
          const { clientX, clientY } = event;
          // 计算并设定容器元素的原点坐标（左上角）
          const x = computeCoord(innerWidth, clientWidth, clientX);
          const y = computeCoord(innerHeight, clientHeight, clientY, 10);
          containerNode.style.left = `${x + 2}px`;
          containerNode.style.top = `${y}px`;
          // 添加一次性点击事件监听器 以在鼠标点击后移除右键内容
          contentNode.style.display = 'block';
          document.addEventListener('mousedown', hiddenRightClickEvent, {
            once: true,
          });
          if (scollNode) {
            scollNode.addEventListener('scroll', scrollEvent, {
              once: true,
            });
          }
          if (menuShowCallback && clientWidth !== 0 && clientHeight !== 0) {
            menuShowCallback(true);
          }
        }
        // 拦截浏览器弹出原生右键菜单
        event.preventDefault();
      };
    }
  },
};
export default directive;
